var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroplrFilePlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "single-folded",
    transform: "translate(9.000000, 8.000000)",
    fillRule: "nonzero",
    fill: "#A1AAB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,1 C16,0.44771525 15.5522847,0 15,0 C14.4477153,0 14,0.44771525 14,1 L14,7 C14,7.55228475 14.4477153,8 15,8 L21,8 C21.5522847,8 22,7.55228475 22,7 C22,6.44771525 21.5522847,6 21,6 L16,6 L16,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C15.2652165,0 15.5195704,0.10535684 15.7071068,0.292893219 L21.7071068,6.29289322 C21.8946432,6.4804296 22,6.73478351 22,7 L22,23 C22,23.5522847 21.5522847,24 21,24 L1,24 C0.44771525,24 0,23.5522847 0,23 L0,1 C0,0.44771525 0.44771525,0 1,0 L15,0 Z M2,2 L2,22 L20,22 L20,7.41421356 L14.5857864,2 L2,2 Z",
    id: "Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplrFilePlaceHolder);
export default __webpack_public_path__ + "static/media/DroplrFilePlaceHolder.b71028715aa9b8f1c1ff3d9c940938cb.svg";
export { ForwardRef as ReactComponent };